export const fonts = {
  /**
   * Used for headings larger than 20px.
   */
  display: '"Source Sans Pro", sans-serif',
  /**
   * Used for code and sometimes numbers in tables.
   */
  mono: '"Inconsolata", monospace',
  /**
   * Used for text and UI (which includes almost anything).
   */
  ui: '"Source Sans Pro", sans-serif',
}
